import { useState } from 'react';
import { Star, X } from 'lucide-react';

const UserSurvey = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    overallRating: 0,
    usability: 0,
    aiEffectiveness: 0,
    safetyValue: 0,
    improvements: '',
    wouldRecommend: null,
    features: []
  });

  const handleStarRating = (category, rating) => {
    setFormData(prev => ({ ...prev, [category]: rating }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto relative">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
        >
          <X className="h-6 w-6" />
        </button>

        <h2 className="text-2xl font-bold mb-6">Help Us Improve Aviation Advisor</h2>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Star Rating Sections */}
          {[
            { id: 'overallRating', label: 'Overall Experience' },
            { id: 'usability', label: 'Ease of Use' },
            { id: 'aiEffectiveness', label: 'AI Assistant Effectiveness' },
            { id: 'safetyValue', label: 'Value for Flight Safety' }
          ].map(({ id, label }) => (
            <div key={id} className="space-y-2">
              <label className="block font-medium">{label}</label>
              <div className="flex space-x-2">
                {[1, 2, 3, 4, 5].map((rating) => (
                  <button
                    key={rating}
                    type="button"
                    onClick={() => handleStarRating(id, rating)}
                    className="focus:outline-none"
                  >
                    <Star
                      className={`h-8 w-8 ${
                        rating <= formData[id]
                          ? 'fill-yellow-400 text-yellow-400'
                          : 'text-gray-300'
                      }`}
                    />
                  </button>
                ))}
              </div>
            </div>
          ))}

          {/* Would Recommend */}
          <div className="space-y-2">
            <label className="block font-medium">Would you recommend Aviation Advisor to other pilots?</label>
            <div className="flex space-x-4">
              {['Yes', 'No', 'Maybe'].map((option) => (
                <button
                  key={option}
                  type="button"
                  onClick={() => setFormData(prev => ({ ...prev, wouldRecommend: option }))}
                  className={`px-4 py-2 rounded-lg ${
                    formData.wouldRecommend === option
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-100 hover:bg-gray-200'
                  }`}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>

          {/* Features Used */}
          <div className="space-y-2">
            <label className="block font-medium">Which features did you find most valuable?</label>
            <div className="grid grid-cols-2 gap-2">
              {[
                'Pre-flight Checklist',
                'Risk Assessment',
                'Weather Analysis',
                'Flight Planning',
                'Post-flight Review',
                'AI Chat Assistant'
              ].map((feature) => (
                <label key={feature} className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    checked={formData.features.includes(feature)}
                    onChange={(e) => {
                      setFormData(prev => ({
                        ...prev,
                        features: e.target.checked
                          ? [...prev.features, feature]
                          : prev.features.filter(f => f !== feature)
                      }));
                    }}
                    className="rounded"
                  />
                  <span>{feature}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Improvements */}
          <div className="space-y-2">
            <label className="block font-medium">What could we improve?</label>
            <textarea
              value={formData.improvements}
              onChange={(e) => setFormData(prev => ({ ...prev, improvements: e.target.value }))}
              className="w-full rounded-lg border p-2 h-32"
              placeholder="Share your suggestions..."
            />
          </div>

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
          >
            Submit Feedback
          </button>
        </form>
      </div>
    </div>
  );
};

export default UserSurvey; 